// Mutation responses are only checked for success and the list is refetched by
// invalidation, so they select the record's own fields and nothing about its author (§11).
const fields = `
            id
            key
            name
            description
            status
            created
            updated`;

export const createBillingProvider = `
    mutation createBillingProvider($input: CreateBillingProviderInput!) {
        createBillingProvider(input:$input) {${fields}
    }
}`;

export const updateBillingProvider = `
    mutation updateBillingProvider($input: UpdateBillingProviderInput!) {
        updateBillingProvider(input:$input) {${fields}
        }
}`;

export const enableBillingProvider = `
    mutation enableBillingProvider($id: ID!) {
        enableBillingProvider(id: $id) {${fields}
        }
    }`;

export const disableBillingProvider = `
    mutation disableBillingProvider($id: ID!) {
        disableBillingProvider(id: $id) {${fields}
        }
    }`;

export const deleteBillingProvider = `
    mutation deleteBillingProvider($input: DeleteBillingProviderInput!) {
        deleteBillingProvider(input:$input) 
}`;
